import { AuthTypeSelectOptions } from '@/containers/pages/filials/edit/utiils';
import { Select } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IconChevronDown } from '@tabler/icons';
interface IAuthTypeSelectProps {
  label?: string;
  placeholder: string;
  value?: number | null;
  form?: UseFormReturnType<any>;
  fieldName: string;
  disabled?: boolean;
}
const AuthTypeSelect = ({
  label,
  placeholder,
  value,
  form,
  fieldName,
  disabled
}: IAuthTypeSelectProps) => {
  const handleChangeConnection = (query: string | null) => {
    form?.setFieldValue(fieldName, query ? Number(query) : null);
  };

  return (
    <Select
      data={AuthTypeSelectOptions}
      required
      allowDeselect={false}
      disabled={disabled}
      rightSectionWidth={30}
      rightSection={<IconChevronDown size="1rem" color="#98A2B3" />}
      label={label}
      value={value?.toString() || ''}
      placeholder={placeholder}
      onChange={handleChangeConnection}
      error={form?.getInputProps(fieldName).error}
      w="100%"
      comboboxProps={{ zIndex: 1300 }}
      styles={() => ({
        rightSection: { pointerEvents: 'none' }
      })}
    />
  );
};

export default AuthTypeSelect;
